import React from 'react';
import { useSelector } from 'react-redux';
import { ChronosDate } from '../../_helpers';

const DEFAULT_DATE_MASK = `$DD$ $MMMM$ $YYYY$`;

export function SidebarDateDisplay({ from, to, calendar }) {
  const { details: world } = useSelector((state) => state.world);

  let posSuffix = '';
  let negSuffix = '';

  if (world && world.worldTime) {
    let preAbbr = world.worldTime.beforeZeroAbbr;
    let postAbbr = world.worldTime.afterZeroAbbr;
    if (preAbbr && preAbbr.length > 0) {
      negSuffix = preAbbr;
    }
    if (postAbbr && postAbbr.length > 0) {
      posSuffix = postAbbr;
    }
  }

  const startDate = new ChronosDate(from, { calendar }).format(
    calendar.dateMask || DEFAULT_DATE_MASK,
    undefined,
    posSuffix,
    negSuffix
  );

  const endDate =
    to && to !== null
      ? new ChronosDate(to, { calendar }).format(
          calendar.dateMask || DEFAULT_DATE_MASK,
          undefined,
          posSuffix,
          negSuffix
        )
      : '';

  return (
    <div className="chronos-sidebar-date-display">
      {from && from !== null && (
        <span className="chronos-sidebar-date chronos-sidebar-date-start">
          {startDate}
        </span>
      )}
      {to && to !== null && (
        <React.Fragment>
          <span className="chronos-sidebar-date-separator">-</span>
          <span className="chronos-sidebar-date chronos-sidebar-date-end">
            {endDate}
          </span>
        </React.Fragment>
      )}
    </div>
  );
}
